import { render, staticRenderFns } from "./WxProductionUnitMultiSelector.vue?vue&type=template&id=9409f9d6&scoped=true"
import script from "./WxProductionUnitMultiSelector.vue?vue&type=script&lang=js"
export * from "./WxProductionUnitMultiSelector.vue?vue&type=script&lang=js"
import style0 from "./WxProductionUnitMultiSelector.vue?vue&type=style&index=0&id=9409f9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9409f9d6",
  null
  
)

export default component.exports